import Request from "@/helpers/services/request.service";

const GroupService = {
    groups: async function () {
        const requestData = {
            method: "get",
            url: "/api/groups",
        };
        return Request(requestData);
    },
    users: async function () {
        const requestData = {
            method: "get",
            url: "/api/users/selectlist"
        };
        return Request(requestData);
    },
    groupSelectList: async function () {
        const requestData = {
            method: "get",
            url: "/api/groups/selectlist",
        };
        return Request(requestData);
    },
    networkSelectList: async function () {
        const requestData = {
            method: "get",
            url: "/api/networks/selectlist",
        };
        return Request(requestData);
    },
    groupNetworkSelectList: async function (groupId) {
        const requestData = {
            method: "get",
            url: "/api/group/"+groupId+"/networks/selectlist",
        };
        return Request(requestData);
    },
    groupUsersSelectList: async function (groupId) {
        const requestData = {
            method: "get",
            url: "/api/group/" + groupId + "/users",
        };
        return Request(requestData);
    },
    deleteGroup: async function (id) {
        const requestData = {
            method: "post",
            url: "/api/group/delete",
            data: { 'Id': id }
        };
        return Request(requestData);
    },
    updateGroup: async function(g) {
        const requestData = {
            method: "post",
            url: "/api/group/update",
            data: g
        };
        return Request(requestData);
    },
    addGroup: async function (group) {
        const requestData = {
            method: "post",
            url: "/api/group",
            data: group 
        };
        return Request(requestData);
    }
};

export default GroupService;
